import React from "react";
import { useNavigate } from "react-router-dom";
import "./BotonMateria.css";

const BotonMateria = ({
  imagen,
  nombre,
  descripcion,
  salon,
  profesor,
  redireccion,
  onEditarClase,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onEditarClase({ nombre, descripcion, salon, profesor });
    navigate(redireccion);
  };

  return (
    <button
      type="button"
      className="boton-materia"
      onClick={handleClick}
      aria-label={`Abrir curso ${nombre}`}
    >
      <span className="boton-materia-portada">
        <img src={imagen} alt="" className="boton-materia-imagen" />
        <span className="boton-materia-etiqueta">Curso</span>
      </span>

      <span className="boton-materia-contenido">
        <span className="boton-materia-encabezado">
          <span className="boton-materia-nombre">{nombre}</span>
          <span className="boton-materia-flecha" aria-hidden="true">
            →
          </span>
        </span>

        <span className="boton-materia-descripcion">
          {descripcion || "Consulta el contenido y las actividades del curso."}
        </span>

        <span className="boton-materia-datos">
          <span className="boton-materia-dato">
            <span>Clave</span>
            <strong>{salon || "Sin asignar"}</strong>
          </span>
          <span className="boton-materia-dato">
            <span>Docente</span>
            <strong>{profesor || "Sin asignar"}</strong>
          </span>
        </span>

        <span className="boton-materia-accion">Ver curso</span>
      </span>
    </button>
  );
};

export default BotonMateria;
